import { render, staticRenderFns } from "./VedTable.vue?vue&type=template&id=d7070546&scoped=true&"
import script from "./VedTable.vue?vue&type=script&lang=js&"
export * from "./VedTable.vue?vue&type=script&lang=js&"
import style0 from "./VedTable.vue?vue&type=style&index=0&id=d7070546&scoped=true&lang=css&"
import style1 from "./VedTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7070546",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
